import './Login.css';

import { Component } from 'react';
import { Flow } from 'flow-react';
import { Container, Row, Col} from 'react-bootstrap';

class Login extends Component {
  state = {
    user: '',
    pass: '',
    initdone: false,
    loggedin: false,
		mess: ''
  }

  changeInput = evt => {
    this.setState({[evt.target.name]: evt.target.value});
  }

  handleSubmit = evt => {
    evt.preventDefault();
    if (this.state.initdone)
      this.trybaseLogin();
    else
      this.props.flow.init()
        .then(()=>{ 
          this.setState({initdone: true});
          this.trybaseLogin();
				});
  }
	
	
	async trybaseLogin() {
		this.tryLogin();
		// this.props.flow.login('pjdemo_dummy_1','gDw5%_wE')
			// .then(res=>{
				// this.tryLogin()
			// }).catch(e => {
				// console.error(e);
		// });
	}

	
	// Votre identifiant ou votre mot de passe est incorrect.
  tryLogin = () => {
    this.props.flow.ftvfeLogin(this.state.user,this.state.pass)
      .then(res=>{
				if(res.msg.user && res.msg.user.id) 
					this.props.logincb({user:res.msg.user});
				else {
					this.setState({mess: 'Votre identifiant ou votre mot de passe est incorrect.'});
					// this.props.logincb({user:false});
				}
      }).catch(e => {
					this.props.logincb({user:false});
      });
  }

  render() {
		let errdiv = (this.state.mess == '') ? null : <div className="loginerrormess">{ this.state.mess }</div>
    return (
			<Container className="Login" fluid>
				<Row>
				<Col md={1} /> 
					<Col md={11}> 
						<div className="login_welcome">Bienvenue sur</div>
						
							
						<form className="form" onSubmit={this.handleSubmit}>
							<div className="formrow">
								<div className="login_instruct">Se connecter</div>
								{errdiv}
							</div>
							<div className="formrow">
								<div>E-mail</div>
								<input type="text" value={ this.state.user } name="user" onChange={ this.changeInput } />
							</div>
							<div className="formrow">
								<div>Mot de passe</div>
								<input type="password" value={ this.state.pass } name="pass" onChange={ this.changeInput } />
								<div onClick={  this.props.pwforgotcb } className="pwforgotlink">Mot de passe oublié ?</div>
							</div>
							<div className="formrow logbutrow">
								<input className="loginsubmit" type="submit" value="Connexion" />
								<div onClick={  this.props.registercb } className="pwforgotlink">Inscrivez-vous</div>
							</div>
						</form>
						<div className="login_footer">Direction de la communication</div>
					</Col>
				</Row>
      </Container>
    );
  }
}

export default Flow.injectFlow(Login);